<div class="info" [ngClass]="['info--'+ type, 'info--'+ direction]">
  <div class="info__item" [class.info__item--icon-end]="item.iconPosition === PageDirectionEnum.Ltr">
    <div class="info__item-icon" *ngIf="item.icon">
      <app-icon  [direction]="item.iconDirection === PageDirectionEnum.Ltr? PageDirectionEnum.Ltr:layoutService.websiteDirection$.value" [name]="item.icon " [type]="item.iconType || IconType.SVG" [size]="item.iconSize || 'md'" [ngClass]="item.iconColor"></app-icon>
    </div>
    <div class="info__item-content">
      <div class="info__item-label">{{ item.label }}</div>
      <div class="info__item-value text-900 weight-medium">
        <ng-container *ngIf="item.riyalValue; else plainValue">
          <span riyalCurrency>{{ item.value || 'ــ ــ' }}</span>
          <small class="info__item-suffix">{{ item.suffix }}</small>
        </ng-container>
        <ng-template #plainValue>
          {{ item.value || 'ــ ــ' }}
          <small class="info__item-suffix">{{ item.suffix }}</small>
        </ng-template>
      </div>
    </div>
  </div>
</div>
